import React from 'react';

import { LargeCenteredContainer } from '@eika/engine-view';

import { CardControlContextProvider } from '@/context/card-control/CardControlContextProvider';
import { useCard } from '@/react-query/hooks/query/use-card';

import { CardControl } from '@components/card-control/CardControl';
import CardControlSkeleton from '@components/card-control/skeleton/CardControlSkeleton';

const SpendingLimitsPage = () => {
    const card = useCard().data;

    if (typeof card === 'undefined') {
        return (
            <LargeCenteredContainer>
                <CardControlSkeleton />
            </LargeCenteredContainer>
        );
    }

    return (
        <div className="sgw-layout medium-centered-container">
            <div className="sgw-layout-item">
                <div className="sgw-layout-item">
                    <CardControlContextProvider>
                        <CardControl />
                    </CardControlContextProvider>
                </div>
            </div>
        </div>
    );
};

export default SpendingLimitsPage;
